import gsap from "gsap"
import { keycodes, math, support } from "./utils"
import AboutText from "./home/about-text"
import AboutImage from "./home/about-image"
import IntroParallax from "./home/introduction-parallax"
import AboutShape from "./home/about-shape";

class ScrollManager {
  constructor() {
    this.bindFns()

    this.DOM = {
      content: document.querySelector('[data-scroll]'),
      sections: document.querySelectorAll('[data-scroll-section]'),
      anchors: document.querySelectorAll('[data-scroll-to]'),
    }

    this.viewport = {
      height: window.innerHeight,
      width: window.innerWidth
    }

    this.raf = null
    this.pause = false

    this.options = {
      firefoxMultiplier: 15,
      keyStep: 120
    }

    this.data = {
      keyPress: true,
      current: 0,
      target: 0,
      ease: 0.115,
      scrollHeight: this.DOM.content.getBoundingClientRect().height,
    }

    if (support.touch) {
      document.body.classList.add('is-mobile')
    }

    this.animatedSections = []

    this.introParallax = new IntroParallax({ section: document.querySelector(".introduction"), scrollManager: this })
    this.aboutText = new AboutText({ section: document.querySelector("#about"), scrollManager: this })
    this.aboutImage = new AboutImage({ section: document.querySelector(".about__image--lower"), scrollManager: this })
    this.aboutShape = new AboutShape({ section: document.querySelector("#about"), scrollManager: this })

    this.animatedSections.push(this.introParallax)
    this.animatedSections.push(this.aboutText)
    this.animatedSections.push(this.aboutImage)
    this.animatedSections.push(this.aboutShape)

    this.init()

  }

  bindFns() {
    ['run',
      'wheel',
      'scroll',
      'resize',
      'keyDown',
      'bindAnchors'].forEach(fn => (this[fn] = this[fn].bind(this)))
  }

  animateSections() {
    this.animatedSections.forEach(section => section && section.run())
  }

  wheel(e) {
    if (this.pause) return

    if (support.firefox && e.deltaMode == 1) {
      this.data.target += e.deltaY * this.options.firefoxMultiplier
    } else {
      this.data.target += e.deltaY
    }

    this.clampTarget()

  }

  scroll(e) {
    this.data.target = window.pageYOffset
  }

  keyDown(e) {
    if (!this.data.keyPress) return;

    switch (e.keyCode) {
      case keycodes.LEFT:
        //this.data.target = this.options.keyStep
        break

      case keycodes.UP:
        this.data.target -= this.options.keyStep
        this.clampTarget()
        break

      case keycodes.RIGHT:
        // this.data.target = - this.options.keyStep
        break

      case keycodes.DOWN:
        this.data.target += this.options.keyStep
        this.clampTarget()
        break

      case e.shiftKey && keycodes.SPACE:
        this.data.target -= this.viewport.height
        this.clampTarget()
        break

      case keycodes.SPACE:
        this.data.target += this.viewport.height
        this.clampTarget()
        break

      default:
        return
    }
  }

  clampTarget() {
    this.data.target = math.clamp(0, this.data.scrollHeight - this.viewport.height, this.data.target)
  }

  run() {
    this.requestAnimationFrame()

    if (support.touch) { // do mobile stuff

      this.data.current = this.data.target

    } else { // do desktop stuff

      this.data.current = math.lerp(this.data.current, this.data.target, this.data.ease).toFixed(2)

      if (this.data.current < 0.1) {
        this.data.current = 0
      }

      this.DOM.sections.forEach(section => {
        section.style.transform = `translate3d(0, ${-1 * this.data.current}px, 0)`
      })

      this.animatedSections && this.animateSections({ scrollTop: this.data.current, target: this.data.target })

    }

  }

  requestAnimationFrame() {
    this.raf = requestAnimationFrame(this.run)
  }

  cancelAnimationFrame() {
    cancelAnimationFrame(this.raf)
  }

  bindAnchors(el) {
    const scrollToElement = document.querySelector(el.dataset.scrollTo)

    if (!scrollToElement) return

    el.addEventListener("click", () => {
      const position = scrollToElement.getBoundingClientRect().top
      this.scrollTo((parseInt(this.data.current) + position) - 80)
    })
  }

  scrollTo(target) { // this function needs to be adjusted for mobile!
    this.data.target = target
  }

  init() {
    // prep browser for transform
    this.DOM.sections.forEach(section => {
      section.style.transform = `translate3d(0, ${-1 * this.data.scrollHeight - this.viewport.height}px, 0)`
      section.style.transform = `translate3d(0, 0, 0)`
    })

    this.run()

    this.DOM.anchors.forEach(this.bindAnchors)

    if (support.touch) {
      window.addEventListener('scroll', this.scroll)
      window.addEventListener('resize', this.resize)
    } else {
      window.addEventListener('wheel', this.wheel)
      window.addEventListener('resize', this.resize)
      window.addEventListener('keydown', this.keyDown)
    }

  }

  destroy() {
    this.cancelAnimationFrame()

    if (support.touch) {
      window.removeEventListener('scroll', this.scroll)
      window.removeEventListener('resize', this.resize)
    } else {
      window.removeEventListener('wheel', this.wheel)
      window.removeEventListener('resize', this.resize)
      window.removeEventListener('keydown', this.keyDown)
    }
  }

  resize() {
    this.data.scrollHeight = this.DOM.content.getBoundingClientRect().height

    this.animatedSections.forEach(section => section.resize && section.resize())

    this.viewport = {
      height: window.innerHeight,
      width: window.innerWidth
    }
  }
}

export default ScrollManager
